/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hw_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your height to see your healthy weight range.`)
};

const es_hw_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce tu altura para ver tu rango de peso saludable.`)
};

const de_hw_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie Ihre Größe ein, um Ihren gesunden Gewichtsbereich zu sehen.`)
};

const nl_hw_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer uw lengte in om uw gezonde gewichtsbereik te zien.`)
};

const fr_hw_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez votre taille pour voir votre plage de poids santé.`)
};

const it_hw_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci la tua altezza per vedere il tuo intervallo di peso sano.`)
};

const pt_br2_hw_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite sua altura para ver sua faixa de peso saudável.`)
};

const pt_hw_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite a sua altura para ver o seu intervalo de peso saudável.`)
};

const ja_hw_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身長を入力して、健康的な体重範囲を確認してください。`)
};

const zh_hw_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入您的身高以查看健康体重范围。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hw_enter = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hw_enter(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hw_enter", locale)
	if (locale === "en") return en_hw_enter(inputs)
	if (locale === "es") return es_hw_enter(inputs)
	if (locale === "de") return de_hw_enter(inputs)
	if (locale === "nl") return nl_hw_enter(inputs)
	if (locale === "fr") return fr_hw_enter(inputs)
	if (locale === "it") return it_hw_enter(inputs)
	if (locale === "pt-BR") return pt_br2_hw_enter(inputs)
	if (locale === "pt") return pt_hw_enter(inputs)
	if (locale === "ja") return ja_hw_enter(inputs)
	return zh_hw_enter(inputs)
};